export default __webpack_public_path__ + "static/media/Product1.7eeb8a9e.PNG";